import type { MacroStepV1 } from "../types";

export function appendRecordedStep(steps: MacroStepV1[], step: MacroStepV1): MacroStepV1[] {
  const last = steps.at(-1);
  if (step.kind === "insert" && last?.kind === "insert") {
    return [...steps.slice(0, -1), { kind: "insert", text: last.text + step.text }];
  }
  return [...steps, step];
}

export function summarizeStep(step: MacroStepV1): string {
  if (step.kind === "insert") return `Insert ${JSON.stringify(step.text.length > 28 ? `${step.text.slice(0, 28)}…` : step.text)}`;
  if (step.kind === "command") return step.command.replaceAll("-", " ");
  return `${step.action.replaceAll("-", " ")} ${JSON.stringify(step.query.query)}`;
}
